import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  title: {
    fontSize: '21px',
    fontFamily: 'Source Sans Pro Semibold',
    flex: '1 0 auto',
  },

  addRoot: { backgroundColor: theme.palette.common.white, flex: '0 0 auto' },
  addLabel: { fontFamily: 'Source Sans Pro Semibold' },

  subTitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.4),
  },
})
